import React from "react";
import { PeppolStatus } from "./PeppolStatus";

interface Props {
  compliance: server.dto.CompanyCanReceivePeppol;
}

const error: server.dto.CompanyCanReceivePeppolCompliances[] = [
  "countryNotSupported",
  "companyInformationMissing",
];

const warning: server.dto.CompanyCanReceivePeppolCompliances[] = [
  "notFoundOnPeppol"
];

const success: server.dto.CompanyCanReceivePeppolCompliances[] = [
  "foundOnPeppol",
];

export const CompanyCanReceivePeppol = (props: Props) => {

  if (!props.compliance) {
    return null;
  }

  let icon: "ok" | "warning" | "error";
  if (error.includes(props.compliance.value)) {
    icon = "error";
  } else if (warning.includes(props.compliance.value)) {
    icon = "warning";
  } else if (success.includes(props.compliance.value)) {
    icon = "ok";
  }

  return <PeppolStatus icon={icon!} label={props.compliance.message} subLabel={props.compliance.messageSublabel} />
}